import styled from "styled-components";
import Button from "../../Button";
export const InvisiblePlaceholderButton = styled(Button) `
  pointer-events: none;
  visibility: hidden;
  opacity: 0;
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiSW52aXNpYmxlUGxhY2Vob2xkZXJCdXR0b24uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvY29tcG9uZW50cy9SZXNvdXJjZUxpc3Qvc3R5bGVkL0ludmlzaWJsZVBsYWNlaG9sZGVyQnV0dG9uLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sTUFBTSxNQUFNLG1CQUFtQixDQUFDO0FBQ3ZDLE9BQU8sTUFBTSxNQUFNLGNBQWMsQ0FBQztBQUVsQyxNQUFNLENBQUMsTUFBTSwwQkFBMEIsR0FBRyxNQUFNLENBQUMsTUFBTSxDQUFDLENBQUE7Ozs7Q0FJdkQsQ0FBQyJ9